<template>
  <div>
    <a-select
      v-model="selectValue"
      show-search
      mode="tags"
      :filter-option="false"
      :placeholder="placeholder"
      :maxTagCount="1"
      @change="handleChange"
      @search="handleSearch"
    >
      <a-select-option
        v-for="(item, index) in data"
        :key="index"
        :value="item.id"
      >
        {{ item[searchKey] }}
      </a-select-option>
      <template slot="notFoundContent">
        <slot name="notFoundContent" />
      </template>
    </a-select>
  </div>
</template>

<script>
export default {
  props: {
    Axios: Function,
    placeholder: {
      type: String,
      default: "请选择",
    },
    searchKey: {
      type: String,
      default: "companyName",
    },
    value: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      selectValue: [],
      params: {
        filter: ``,
        pageSize: 100,
      },
      searchDataTimeout: null,
      data: [],
      currentSelectData: null,
    };
  },
  created() {
    console.log(this.value);
    if (this.value) {
      this.selectValue = [this.value];
      // this.params.filter = `id="${this.value}"`
    }
    // this.getData()
  },
  methods: {
    async getData() {
      try {
        console.log("this.params", this.params);
        const { result } = await this.Axios(this.params);
        this.data = result.items;
      } catch (error) {
        console.log(error);
      }
    },
    handleChange(value) {
      console.log(value);
      if (!value[0]) {
        this.selectValue = [];
        this.currentSelectData = null;
      } else {
        this.selectValue = [value[value.length - 1]];
        this.currentSelectData = this.data.filter(
          (v) => v.id === this.selectValue[0]
        )[0];
      }
      console.log(1);
      // this.$emit("input", this.selectValue[0]);
      const res = {
        companyInfo: this.data?.find((v) => v.id === this.selectValue[0]),
      };
      res.companyName =
        res.companyInfo?.companyName?.trim() || this.selectValue[0]?.trim();
      console.log(res);
      this.$emit("input", res);
    },
    handleSearch(input) {
      if (this.searchDataTimeout) {
        clearTimeout(this.searchDataTimeout);
      }
      this.searchDataTimeout = setTimeout(async () => {
        this.params.filter = `${this.searchKey} like "${input?.trim()}"`;
        await this.getData();
        this.searchDataTimeout = null;
      }, 300);
    },
    getDataItem() {
      return this.currentSelectData;
    },
  },
};
</script>
